export const FRAUD_COLORS = {
  low: 'success',      // Vuetify green
  medium: 'warning',   // Vuetify orange/yellow
  high: 'error',       // Vuetify red
  none: 'grey',        // Vuetify grey
}

export const FRAUD_LABELS = {
  low: 'Rendah',
  medium: 'Sedang',
  high: 'Tinggi',
  none: 'Tidak Ada',
}

export const INDIKASI_LABELS = {
  lokasi: 'Lokasi Presensi Identik',
  versi: 'Versi aplikasi',
}
